import './Vrat.scss';
import Brightness3Icon from '@mui/icons-material/Brightness3';
import FestivalIcon from '@mui/icons-material/Festival';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import LandscapeIcon from '@mui/icons-material/Landscape';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import SpaIcon from '@mui/icons-material/Spa';
import StarPurple500Icon from '@mui/icons-material/StarPurple500';
import Brightness5Icon from '@mui/icons-material/Brightness5';
import ChurchIcon from '@mui/icons-material/Church';
import TempleBuddhistIcon from '@mui/icons-material/TempleBuddhist';
import PeopleIcon from '@mui/icons-material/People';
import PublicIcon from '@mui/icons-material/Public';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import BookIcon from '@mui/icons-material/Book';
import { Link } from 'react-router-dom';

const Vrat = ({ onClose }) => {
  return (
    <div className="vrat-modal-overlay" onClick={onClose}>
      <div className="vrat-modal-content" onClick={e => e.stopPropagation()}>
        <div className="vrat-container">
          <h2>Vrat & Upavas</h2>
          <div className="vrat-grid">

            <Link to="/vrat/sankashti-chaturthi" className="vrat-item">
              <Brightness3Icon className="icon" />
              <div><h4>Sankashti Chaturthi</h4></div>
            </Link>

            <Link to="/vrat/ekadashi" className="vrat-item">
              <SpaIcon className="icon" />
              <div><h4>Ekadashi</h4></div>
            </Link>

            <Link to="/vrat/purnima-dates" className="vrat-item">
              <Brightness5Icon className="icon" />
              <div><h4>Purnima Dates</h4></div>
            </Link>

            <Link to="/vrat/amavasya-dates" className="vrat-item">
              <Brightness3Icon className="icon" />
              <div><h4>Amavasya Dates</h4></div>
            </Link>

            <Link to="/vrat/vinayaka-chaturthi" className="vrat-item">
              <FestivalIcon className="icon" />
              <div><h4>Vinayaka Chaturthi</h4></div>
            </Link>

            <Link to="/vrat/chandra-darshan" className="vrat-item">
              <WbTwilightIcon className="icon" />
              <div><h4>Chandra Darshan</h4></div>
            </Link>

            <Link to="/vrat/pradosham-dates" className="vrat-item">
              <SelfImprovementIcon className="icon" />
              <div><h4>Pradosham Dates</h4></div>
            </Link>

            <Link to="/vrat/sankranti-dates" className="vrat-item">
              <LandscapeIcon className="icon" />
              <div><h4>Sankranti Dates</h4></div>
            </Link>

            <Link to="/vrat/satyanarayana-puja" className="vrat-item">
              <TempleBuddhistIcon className="icon" />
              <div><h4>Satyanarayana Puja</h4></div>
            </Link>

            <Link to="/vrat/masik-shivaratri" className="vrat-item">
              <SelfImprovementIcon className="icon" />
              <div><h4>Masik Shivaratri</h4></div>
            </Link>

            <Link to="/vrat/masik-durgaashtami" className="vrat-item">
              <StarPurple500Icon className="icon" />
              <div><h4>Masik Durgaashtami</h4></div>
            </Link>

            <Link to="/vrat/masik-kalashtami" className="vrat-item">
              <StarPurple500Icon className="icon" />
              <div><h4>Masik Kalashtami</h4></div>
            </Link>

            <Link to="/vrat/krathigai-dates" className="vrat-item">
              <EmojiEventsIcon className="icon" />
              <div><h4>Krathigai Dates</h4></div>
            </Link>

            <Link to="/vrat/shraddha-dates" className="vrat-item">
              <PeopleIcon className="icon" />
              <div><h4>Shraddha Dates</h4></div>
            </Link>

            <Link to="/vrat/janmashtami-dates" className="vrat-item">
              <ChurchIcon className="icon" />
              <div><h4>Janmashtami Dates</h4></div>
            </Link>

            <Link to="/vrat/skanda-sashthi" className="vrat-item">
              <AccessibilityNewIcon className="icon" />
              <div><h4>Skanda Sashthi</h4></div>
            </Link>

            <Link to="/vrat/iskon-ekadashi" className="vrat-item">
              <PublicIcon className="icon" />
              <div><h4>Iskon Ekadashi</h4></div>
            </Link>

            <Link to="/vrat/vrat-katha" className="vrat-item">
              <BookIcon className="icon" />
              <div><h4>Vrat Katha</h4></div>
            </Link>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Vrat;
